// Libraries
import _ from 'lodash';
import React from 'react';

// Supermove
import {Space} from '@supermove/components';
import {ResponsiveType} from '@supermove/hooks';
import {colors} from '@supermove/styles';
import {Phone} from '@supermove/utils';

// App
import ActionPanel from '@shared/design/components/Panel/ActionPanel';
import EditPanel from '@shared/design/components/Panel/EditPanel';
import Text from '@shared/design/components/Text';
import SetupCallrailIntegrationStep from '@shared/modules/CallrailIntegration/enums/SetupCallrailIntegrationStep';
import {FormikSetupCallrailIntegrationFormType} from '@shared/modules/CallrailIntegration/forms/SetupCallrailIntegrationForm';

const ExcludedPhoneNumbersPanel = ({
  form,
  field,
  setCurrentStepKind,
  responsive,
}: {
  form: FormikSetupCallrailIntegrationFormType;
  field: string;
  setCurrentStepKind: (kind: string) => void;
  responsive: ResponsiveType;
}) => {
  const kind = SetupCallrailIntegrationStep.EXCLUDED_PHONE_NUMBERS;
  const step = SetupCallrailIntegrationStep.getStep(kind);
  const excludedPhoneNumbers = _.get(form.values, `${field}.callrailExcludedPhoneNumbers`) || [];

  return (
    <ActionPanel
      title={step.title}
      ActionButtonComponent={() => (
        <EditPanel.EditButton
          handleEdit={() => setCurrentStepKind(kind)}
          isEditing={false}
          isDisabled={false}
        />
      )}
      BodyComponent={() => {
        const fieldPath = `${field}.callrailExcludedPhoneNumbers`;
        const fieldError = form.errors[fieldPath];

        return (
          <React.Fragment>
            <Text.Label style={{color: colors.gray.secondary}}>Excluded Phone Numbers</Text.Label>
            <Space height={8} />
            {excludedPhoneNumbers.length > 0 ? (
              excludedPhoneNumbers.map((phoneNumber: string, index: number) => (
                <Text.Body key={index}>{Phone.display(phoneNumber)}</Text.Body>
              ))
            ) : (
              <Text.Body>No phone numbers excluded</Text.Body>
            )}
            {fieldError && (
              <React.Fragment>
                <Space height={8} />
                <Text.Body style={{color: colors.red.warning}}>{fieldError}</Text.Body>
              </React.Fragment>
            )}
          </React.Fragment>
        );
      }}
    />
  );
};

export default ExcludedPhoneNumbersPanel;
